import { isModifiedClickEvent } from '@grandvisionhq/utils';
import { getParsedDataFromLS } from '../Util/customer-name-persistor.js';

function getActivePath() {
    const url = new URL(window.location.href);
    return url.pathname;
}
const hrefToUrl = (href)=>new URL(`${window.location.origin}${href}`)
;
const getMyAccountMenuItems = (logout, routes, intl, isUserLoggedIn, isAddressBookEnabled, isAabEnabled, onNavigate)=>{
    const activePath = getActivePath();
    const navigate = (href)=>{
        return (e)=>{
            if (isModifiedClickEvent(e)) {
                return;
            }
            e.preventDefault();
            const url = hrefToUrl(href);
            onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(url);
        };
    };
    const logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
            testId: 'logout'
        },
        childMenuItems: [],
        link: {
            href: '',
            type: 'external'
        }
    };
    const loginItem = {
        label: intl.getLabel('account.action.login'),
        childMenuItems: [],
        parameters: {
            testId: 'login'
        },
        link: {
            href: routes.login,
            type: 'external'
        }
    };
    function getProfileChildMenuItems() {
        const items = [];
        if (isAddressBookEnabled) {
            var _addressBook;
            items.push({
                label: intl.getLabel('account.menu.addresses'),
                link: {
                    href: (_addressBook = routes.addressBook) !== null && _addressBook !== void 0 ? _addressBook : '',
                    onClick: routes.addressBook && onNavigate ? navigate(routes.addressBook) : undefined,
                    type: 'external',
                    active: activePath.startsWith(routes.profile)
                },
                parameters: {
                    testId: 'addressBook'
                }
            });
        }
        return items;
    }
    const userHasParsedDataFromLS = getParsedDataFromLS();
    let lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    var _profile, _prescriptions, _orders, _subscriptions, _settings;
    const items1 = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
                testId: 'profile'
            },
            link: {
                href: (_profile = routes.profile) !== null && _profile !== void 0 ? _profile : '',
                onClick: routes.profile && onNavigate ? navigate(routes.profile) : undefined,
                type: 'external',
                active: !!(routes.profile && activePath.startsWith(routes.profile))
            },
            childMenuItems: getProfileChildMenuItems()
        },
        {
            label: intl.getLabel('account.menu.appointments'),
            parameters: {
                icon: 'calendar',
                testId: 'appointments'
            },
            link: {
                href: isAabEnabled && routes.appointments || '',
                onClick: routes.appointments && onNavigate ? navigate(routes.appointments) : undefined,
                type: 'external',
                active: !!(routes.appointments && activePath.startsWith(routes.appointments))
            }
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
                testId: 'prescriptions'
            },
            link: {
                href: (_prescriptions = routes.prescriptions) !== null && _prescriptions !== void 0 ? _prescriptions : '',
                onClick: routes.prescriptions && onNavigate ? navigate(routes.prescriptions) : undefined,
                type: 'external',
                active: !!(routes.prescriptions && activePath.startsWith(routes.prescriptions))
            }
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
                testId: 'orders'
            },
            link: {
                href: (_orders = routes.orders) !== null && _orders !== void 0 ? _orders : '',
                onClick: routes.orders && onNavigate ? navigate(routes.orders) : undefined,
                type: 'external',
                active: !!(routes.orders && activePath.startsWith(routes.orders))
            }
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptions'
            },
            link: {
                href: (_subscriptions = routes.subscriptions) !== null && _subscriptions !== void 0 ? _subscriptions : '',
                onClick: routes.subscriptions && onNavigate ? navigate(routes.subscriptions) : undefined,
                type: 'external',
                active: !!(routes.subscriptions && activePath.startsWith(routes.subscriptions))
            }
        },
        {
            label: intl.getLabel('account.menu.settings'),
            parameters: {
                icon: 'folded-page-with-text',
                testId: 'settings'
            },
            link: {
                href: (_settings = routes.settings) !== null && _settings !== void 0 ? _settings : '',
                onClick: routes.settings && onNavigate ? navigate(routes.settings) : undefined,
                type: 'external',
                active: !!(routes.settings && activePath.startsWith(routes.settings))
            }
        },
        lastItem, 
    ];
    const hasLink = (item)=>{
        var ref;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : ref.href) && item.link.href !== '';
    };
    const hasAction = (item)=>{
        var ref;
        return (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.action;
    };
    return items1.filter((item)=>hasLink(item) || hasAction(item)
    );
};

export { getMyAccountMenuItems };
//# sourceMappingURL=get-my-account-menu-items.js.map
